import { render, staticRenderFns } from "./ArabicSignUp.vue?vue&type=template&id=7d8f206e"
import script from "./ArabicSignUp.vue?vue&type=script&lang=js"
export * from "./ArabicSignUp.vue?vue&type=script&lang=js"
import style0 from "./ArabicSignUp.vue?vue&type=style&index=0&id=7d8f206e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports